// extracted by mini-css-extract-plugin
export default {"homedecorsection":"Homedecor_homedecorsection__y190s"};